import React from 'react';
import PropTypes from 'prop-types';
import { sportTypeIds } from '../../../utils/eventConstants';

const SportLabel = ({ sportTypeId, className, label, style, 'data-testid': dataTestId }) => {
    if (sportTypeId) {
        const sport = sportTypeId === sportTypeIds.TENNIS ? 'tennis' : 'pickleball';
        return <div className={`sport-label ${sport} ${className}`} style={style} data-testid={dataTestId || undefined}>{label || sport}</div>;
    }
    return null;
};

SportLabel.propTypes = {
    sportTypeId: PropTypes.oneOf(Object.values(sportTypeIds)).isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.shape({}),
    'data-testid': PropTypes.string,
};

SportLabel.defaultProps = {
    className: '',
    label: '',
    style: {},
    'data-testid': null,
};

export default SportLabel;
